import { uniqBy } from 'lodash';
import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectLanguagesStatus } from './selectors';
import { LANGUAGES_KEY } from '../lib/constants';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, Language } from '../types';

const INITIAL_LANGUAGE_STATE: Language = {
  name: '',
  code: '',
};

export const loadLanguages = (): Thunk => async (dispatch, getState, { request }) => {
  const KEY = 'languages';
  const endpoint = `${PODCASTERS_SERVICE}/v0/feeds/languages`;

  /* istanbul ignore next */
  if (selectLanguagesStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [KEY]: LOADING }, 'submission/LOAD_LANGUAGES_REQUEST'));

  try {
    const data: Language[] = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [KEY]: uniqBy(data, 'code') }), unsetStatus([KEY])],
        'submission/LOAD_LANGUAGES_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [KEY]: ERROR }, 'submission/LOAD_LANGUAGES_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const initializeLanguage = (): Thunk => dispatch => {
  dispatch(setData({ [LANGUAGES_KEY]: INITIAL_LANGUAGE_STATE }, 'submission/INITIALIZE_LANGUAGE'));
};

export const setLanguage = (language: Language): Thunk => dispatch => {
  dispatch(setData({ [LANGUAGES_KEY]: language }, 'submission/SET_LANGUAGE'));
};
